export default {"src":"/_next/static/media/welcome-zur-institute.53f96450.svg","height":360,"width":451};